<template >
<div>


 <div class="modal" id="staticBackdropUpdateCoupon" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <form v-on:submit.prevent="submit()">
    <div class="modal-content border-primary">
      <div class="modal-header bg-info text-white">
        <h5 class="modal-title" id="staticBackdropLabel">
          <i style="color:#FFCC00" class="fas fa-edit mr-3"></i>
          MODIFICA COUPON</h5>
          <button @click="$emit('close',coupon)" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button> 
      </div>
      
      <div class="modal-body">
          <alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2 mb-2"  ></alert-box>  
          <div class="form-group">
            <label for="input1"><strong>RIFERIMENTO</strong></label>
            <input maxlength="50" type="text" required class="form-control" id="reference" v-model="coupon.reference">            
          </div>
          <div class="form-group">
            <label for="input2"><strong>TELEFONO</strong></label>
            <input type="number" required class="form-control" id="tel" v-model="coupon.tel">
          </div>
          <div class="form-group">
            <label for="input3"><strong>SCADENZA</strong></label>
            <input type="date" class="form-control" id="expire" v-model="coupon.expire_at">
          </div>
          <div class="form-group">
            <label for="formGroupExampleInput4">NOTE</label>
            <input type="text" class="form-control" v-model="coupon.note">        
        </div>

          <!--
          <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="coupon.active">
            <label class="form-check-label" for="exampleCheck1"><strong>ATTIVO</strong></label>
          </div>
        -->

      </div>
      <div class="modal-footer">
        <!--
        <button @click="$emit('close')" type="button" class="btn btn-secondary" data-dismiss="modal">
            <i style ="color:yellow" class="fas fa-reply mr-3" aria-hidden="true"></i>
            CHIUDI</button>
        -->
        <button type="submit" class="btn btn-primary">
          <i style="color:#FFCC00" class="fas fa-save mr-3"></i>
            MODIFICA
            <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
          </button>
      </div>
      
    </div>
    </form>
  </div>
</div>

</div>
</template>
<script>


import api                        from '@/api'
import alertBox                   from '@/components/common/AlertBox.vue'
import {setFmtDate2}              from '@/functions'


export default {
  props:['item'],
  components: {alertBox},
  
 data () {
    return {
    
    coupon    : {},
       
    msg : {
        title : '',
        body  : '',
        type  : 0
      },
      bt_spinner : false


    }
  },
 


created()
{ 
  this.$nextTick(()  => {              
    const newDate = setFmtDate2(this.item.expire_at)
    
    this.coupon   = {'reference' : this.item.reference,
                     'tel'        : this.item.tel,
                     'expire_at'  : newDate,
                     'couponId'   : this.item.couponId,
                     'active'     : this.item.active,
                     'note'       : this.item.note
                    }
    $('#staticBackdropUpdateCoupon').modal('show')
    $('#reference').trigger('focus')
    })  
},
methods :{
  
async submit()
{
  

  this.msg.title = ''
  const sp       = {'sp'    : 'spUpdateCouponData'}
  const data     = this.coupon   
  const json     = Object.assign(data, sp)
  
  this.bt_spinner = true
  await api.post(json).then(res => {
          
       
          if(res.status==200)
            {
                this.msg.title = 'MODIFICA COUPON'
                this.msg.body  = 'EFFETTUATA.'
                this.msg.type  = 0     
                
            }
           else if(res.status==500)
           {
               
       
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                                 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.bt_spinner = false
        });


},



}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}

.form-check-label
{
  cursor: pointer;
}


</style>
